import React from 'react';

function ColormakerFooter(props) {
  const text = props.isMakingAjax ? 'Gatavojam komplektu...' : 'Izveidot krāsu komplektu';
  return (
    <section className="colorset-maker__footer">
      <button
        className="colorset-maker__footer-button"
        onClick={props.onClick}
        disabled={props.isMakingAjax}
      >{text}
      </button>
    </section>
  );
}

export default ColormakerFooter;



// WEBPACK FOOTER //
// ./src/components/colormakerFooter.js